// Security Utilities

/**
 * Escape HTML special characters to prevent XSS attacks
 * @param {string} str - String to escape
 * @returns {string} Escaped string safe for HTML insertion
 */
export function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    if (typeof str !== 'string') str = String(str);

    const htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };

    return str.replace(/[&<>"']/g, char => htmlEscapes[char]);
}

/**
 * Escape HTML for use in attributes
 * @param {string} str - String to escape
 * @returns {string} Escaped string safe for HTML attribute values
 */
export function escapeAttr(str) {
    return escapeHtml(str);
}

/**
 * Sanitize user input for display
 * Removes potentially dangerous content while preserving safe HTML
 * @param {string} str - String to sanitize
 * @returns {string} Sanitized string
 */
export function sanitizeText(str) {
    if (str === null || str === undefined) return '';
    if (typeof str !== 'string') str = String(str);

    // Remove script tags and event handlers
    return str
        .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
        .replace(/on\w+\s*=\s*(['"]).*?\1/gi, '')
        .replace(/on\w+\s*=\s*[^\s>]*/gi, '');
}
